// extracted by mini-css-extract-plugin
export default {"responsiveBottomBar":"Responsive_BottomBar_responsiveBottomBar__QVC4H"};